import React, {useMemo} from 'react'
import {SkeletonCircle, useSlotRecipe} from '@chakra-ui/react3'
import {Flex, Text} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import {AvailabilityIcon} from '../../../components/icons'
import SkeletonText from '../../../components/skeleton-text'
import {productAvailabilityRecipe} from './index.recipe'

const ProductAvailability = ({product, loading, ...props}) => {
    const productAvailability = useMemo(() => product?.c_availability?.toLowerCase(), [product])
    const recipe = useSlotRecipe({recipe: productAvailabilityRecipe})
    const styles = useMemo(
        () => recipe({status: loading ? undefined : productAvailability}),
        [recipe, loading, productAvailability]
    )
    return (
        <Flex {...styles.container} {...props}>
            {!loading ? <AvailabilityIcon boxSize={1.5} /> : <SkeletonCircle size={1.5} />}
            {!loading ? (
                <Text {...styles.text}>{product?.c_availabilityMessage}</Text>
            ) : (
                <SkeletonText
                    noOfLines={1}
                    isLoaded={loading}
                    skeletonHeight="1.3em"
                    textStyle="Regular Small"
                    width="10rem"
                />
            )}
        </Flex>
    )
}

ProductAvailability.propTypes = {
    product: PropTypes.object,
    loading: PropTypes.bool
}

export default ProductAvailability
